export const AccionesUsuario = {
    Insertar: 'I',
    Actualizar: 'U',
    Eliminar: 'D',
    Consultar: 'C'
}

export default AccionesUsuario;